import React from 'react';
import MainSidebarLayout from './main-sidebar-layout';

export default class MainSidebar extends React.Component<any, {}> {
    render(){
        return(
            <MainSidebarLayout/>
        )
    }
}